import {
    Button,
    Card,
    CardBody,
    Col,
    Row
} from "reactstrap";
import './InstituteQuotation.css'
interface Props {

    groupName: string;

    onQuotationClick?: () => void;

}

const InstituteQuotation = ({
    groupName,
    onQuotationClick
}: Props) => {

    return (

        <Card className="trainer-card shadow-sm mb-4 border-0">

            <CardBody>

                <Row className="align-items-center">

                    <Col lg="8">

                        <div className="d-flex align-items-center">

                            <div className="trainer-icon">

                                🎓

                            </div>

                            <div>

                                <h3 className="fw-bold mb-2">

                                    Are You an Institute or Trainer?

                                </h3>

                                <p className="text-muted mb-0">

                                    Do you provide any training or coaching for this course

                                    <strong> "{groupName}" </strong>
                                    ? 

                                    Submit your quotation and special
                                    offers for a group of 10, 20, 50 and 100 students.

                                </p>

                            </div>

                        </div>

                    </Col>

                    <Col
                        lg="4"
                        className="text-lg-end mt-4 mt-lg-0"
                    >

                        <Button
                            color="warning"
                            size="lg"
                            onClick={onQuotationClick}
                        >

                            📩 Send your Offer

                        </Button>

                    </Col>

                </Row>

            </CardBody>

        </Card>

    );

};

export default InstituteQuotation;